import 'vite/modulepreload-polyfill';

import Buefy from 'buefy';
import { createPinia, PiniaVuePlugin } from 'pinia';
import VueMask from 'v-mask';
import Vue from 'vue';
import './assets/css/agreelink-main.css';
import EmailInput from './components/EmailInput.vue';
import HrbrButton from './components/ui/HrbrButton.vue';
import HrbrAddressAutocomplete from './components/ui/HrbrAddressAutocomplete.vue';
import App from './pages/AgreeLink/HrbrAgreeLink.vue';
import ApiPlugin from './plugins/api';
import SuperdocViewerPlugin from './plugins/superdoc-viewer-plugin';
const PdfjsPluginModule = import('./plugins/pdfjs-plugin');

// Plugins
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(pinia);
Vue.use(Buefy, { defaultIconPack: 'fal' });
Vue.use(ApiPlugin, { debug: false });
Vue.use(SuperdocViewerPlugin)
Vue.use(VueMask);
Vue.component('EmailInput', EmailInput);
Vue.component('HrbrButton', HrbrButton);
Vue.component('HrbrAddressAutocomplete', HrbrAddressAutocomplete);

// Dynamic import for code-splitting
PdfjsPluginModule.then((mod) => Vue.use(mod.default)).catch(console.error);

new Vue({
  el: '#agreelink-app',
  pinia,
  render: (h) => h(App),
});
